import React, { useEffect, useRef, useState } from 'react';

const GifBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{ width: '100%', position: 'relative', overflow: 'hidden' }}>
      <style>{`
        .gb-wrapper {
          position: relative;
          width: 100%;
          min-height: 320px;
          background-color: #0d0d0d;
          overflow: hidden;
        }
        .gb-video {
          display: block;
          width: 100%;
          height: auto;
          min-height: 320px;
          max-height: 640px;
          object-fit: cover;
        }
        .gb-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 35%);
          z-index: 1;
          pointer-events: none;
        }
        .gb-caption {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 32px;
          z-index: 2;
          text-align: center;
          padding: 0 20px;
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s;
        }
        .gb-caption.gb--visible { opacity: 1; transform: translateY(0); }
        .gb-eyebrow {
          font-family: Poppins-Medium, sans-serif;
          font-size: 11px;
          letter-spacing: 0.35em;
          text-transform: uppercase;
          color: #717fe0;
          margin: 0 0 10px 0;
          text-shadow: 0 1px 8px rgba(0,0,0,0.7);
        }
        .gb-title {
          font-family: PlayfairDisplay-Bold, serif;
          font-size: 30px;
          color: #fff;
          margin: 0;
          text-shadow: 0 2px 16px rgba(0,0,0,0.75), 0 1px 4px rgba(0,0,0,0.6);
        }
        @media (max-width: 768px) {
          .gb-video { max-height: 320px; }
          .gb-title { font-size: 20px; }
          .gb-caption { bottom: 18px; }
        }
      `}</style>

      <div className="gb-wrapper">
        <video
          src="asset/videos/Toyota_Land_Cruiser_accelerates_…_202607160032.mp4"
          className="gb-video"
          autoPlay
          loop
          muted
          playsInline
          aria-label="Toyota Land Cruiser 250 in motion"
        />
        <div className="gb-overlay" />
        <div className={`gb-caption ${visible ? 'gb--visible' : ''}`}>
          <p className="gb-eyebrow">Engineered to Perform</p>
          <h3 className="gb-title">Feel Every Mile</h3>
        </div>
      </div>
    </section>
  );
};

export default GifBanner;
